import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DashboardState, RootState } from '../types';

const namespaced: boolean = true;
export const PENDING_ORDERS_LIMIT: number = 15;
export const QUOTES_LIMIT: number = 15;

export const state: DashboardState = {
	calendarEvents: [],
	ordersSummary: {} as OrdersSummaryType,
	pendingOrders: [],
	pendingOrdersCount: 0,
	quotes: [],
	quotesCount: 0,
	quotesOffset: 0,
	quotesLimit: QUOTES_LIMIT,
	inquiriesSummary: null,
	filters: {
		startDate: '',
		endDate: '',
		status: [],
		type: []
	},
	pendingOrdersSort: 'created_at',
	pendingOrdersOffset: 0,
	pendingOrdersLimit: PENDING_ORDERS_LIMIT,
	calendarType: 'month'
};

const dashboard: Module<DashboardState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};

export default dashboard;